import "./CsaMedia.css";
import React, { useEffect, useState } from "react";
import {
  Button,
  Dropdown,
  Form,
  Grid,
  Icon,
  Modal,
  TextArea,
} from "semantic-ui-react";
import Files from "react-files";
import { uid } from "uid";
import { connect, useDispatch } from "react-redux";
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import validator from "validator";
import { newMedia } from "../../../store/actions/mediaActions";
import { contentOptions } from "../../../utils/utils";

const Add = (props) => {
  const [error, setError] = useState(null);
  const [url, setUrl] = useState(null);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [fileType, setFileType] = useState(null);
  const [fileURL, setFileURL] = useState(null);
  const [title, setTitle] = useState(null);
  const [content, setContent] = useState(null);

  const dispatch = useDispatch();
  // close function
  const handleClose = () => {
    setError(null);
    setUrl(null);
    setFile(null);
    setFileName(null);
    setFileURL(null);
    setTitle(null);
    setContent(null);
    props.close();
  };
  // Submit Function
  const handleSubmit = () => {
    if (title && content && !error && fileType) {
      if (url && file) {
        setError("Either enter Content URL or File not both");
      } else if (!url && !file) {
        setError("File or URL one of them is required");
      } else {
        const toFirestore = {
          id: uid(8),
          title,
          content,
          file,
          fileName,
          fileType,
          videoURL: url,
        };
        dispatch(newMedia(toFirestore));
      }
    } else setError("All fields are required");
  };

  // useEffects

  // Automatically Closes After Adding to Database
  useEffect(() => {
    if (props.newStwAdd) {
      handleClose();
    }
  }, [props.newStwAdd]);

  // Automatically Clears URL And File upon condition
  useEffect(() => {
    if (url) {
      setFile(null);
      setFileName(null);
      setFileURL(null);
    }
    if (file) {
      setUrl(null);
    }
  }, [url, file]);

  // Automatically Clears Error if all data are there
  useEffect(() => {
    if (title && (file || url) && error && content && fileType) {
      setError(null);
    }
  }, [title, file, url, error, content]);

  return (
    <Modal
      size="tiny"
      className="cu-event-modal"
      onClose={handleClose}
      open={props.open}
    >
      <Modal.Content scrolling>
        <div className="AdminTopButtonsProgressContainer">
          <div className="AdminTopButtonsContainer">
            <Button
              floated="left"
              circular
              icon="close"
              onClick={handleClose}
            />

            <Button
              disabled={error}
              loading={props.newStwAdding}
              floated="right"
              positive
              name="saveButton"
              content="Save"
              labelPosition="right"
              icon="checkmark"
              onClick={handleSubmit}
            />
          </div>
        </div>
        <Form>
          <div className="AdminFormEventContainer add-partner-modal add-edit-video">
            <div className="title-title">
              <h3>Add Media</h3>

              {!url && !file && (
                <p style={{ color: "#FF6600" }}>No Content URL</p>
              )}
              {error && <p style={{ color: "#800000" }}>{error}</p>}
              {props.newStwError && (
                <p style={{ color: "#800000" }}>{props.newStwError.message}</p>
              )}
            </div>
            <Grid divided="vertically">
              {file && (
                <Grid.Row stackable="true" columns={1}>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    {fileType.startsWith("image") && (
                      <div
                        className="image-preview-data full"
                        style={{ background: `url(${fileURL})` }}
                      />
                    )}
                    {fileName && <p className="note cu-center">{fileName}</p>}
                  </Grid.Column>
                </Grid.Row>
              )}
              <Grid.Row stackable="true">
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Form.Field required>
                    <label>Title</label>
                    <input
                      placeholder="Enter Title"
                      id="commitmenttitle"
                      onChange={(e) => {
                        setTitle(e.target.value);
                        error && setError(null);
                      }}
                    />
                  </Form.Field>
                  <Form.Field required>
                    <label>Add Content</label>
                    <TextArea
                      className="cu-textarea"
                      placeholder="Tell us more"
                      onChange={(e) => {
                        setContent(e.target.value);
                        error && setError(null);
                      }}
                    />
                  </Form.Field>
                </Grid.Column>
                {!file && (
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <Form.Field required>
                      <label>Content Type</label>
                      <Dropdown
                        placeholder="Select Content Type"
                        options={contentOptions}
                        selection
                        fluid
                        onChange={(e, data) => setFileType(data.value)}
                      />
                    </Form.Field>
                    <Form.Field required>
                      <label>Content URL</label>
                      <div className="inline-input-group">
                        <div className="first-div">
                          <input
                            placeholder="Enter Content URL"
                            id="commitment_url"
                            disabled={file}
                            onChange={(e) => {
                              if (
                                !e.target.value ||
                                e.target.value.trim() === ""
                              ) {
                                setUrl(null);
                              }
                              if (validator.isURL(e.target.value)) {
                                setUrl(e.target.value);
                                setError(null);
                              } else setError("Invalid URL");
                            }}
                          />
                        </div>
                        <Button
                          icon="cancel"
                          circular
                          negative
                          basic
                          disabled={!url}
                          onClick={() => {
                            setUrl(null);
                          }}
                        />
                      </div>
                    </Form.Field>
                  </Grid.Column>
                )}
                {!url && (
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <div className="inline-input-group">
                      <div className="first-div">
                        <Files
                          className="files-dropzone"
                          accepts={[
                            "image/*",
                            "video/mp4",
                            "video/x-m4v",
                            "video/*",
                            ".heic",
                          ]}
                          clickable
                          multiple={false}
                          onChange={(file) => {
                            setFile(file[0]);
                            setFileName(file[0].name);
                            setError(null);
                            setFileURL(file[0].preview.url);
                            setFileType(file[0].type);
                          }}
                        >
                          <label className="btn-cu ui green button btn-cu w-100">
                            <Icon name="upload" disabled={url} />
                            Upload Document
                          </label>
                        </Files>
                      </div>
                      <Button
                        icon="cancel"
                        circular
                        negative
                        basic
                        disabled={!file}
                        onClick={() => {
                          setFile(null);
                          setFileName(null);
                          setFileURL(null);
                          setFileType(null);
                        }}
                      />
                    </div>
                  </Grid.Column>
                )}
              </Grid.Row>
            </Grid>
          </div>
        </Form>
      </Modal.Content>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
    newStwAdd: state.media.Add,
    newStwError: state.media.AddError,
    newStwAdding: state.media.Adding,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "partners",
      },
      {
        collection: "partnersOrder",
      },
    ];
    return firestoreArray;
  })
)(Add);
